import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-todo-create-dialog',
  templateUrl: './todo-create-dialog.component.html',
  styleUrls: ['./todo-create-dialog.component.scss']
})
export class TodoCreateDialogComponent {
  form = this.fb.group({
    title: ['', Validators.required],
    description: [''],
    priority: ['Medium', Validators.required],
    status: ['Pending', Validators.required],
    dueDate: ['']
  });

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TodoCreateDialogComponent>
  ) {}

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close({
      title: this.form.value.title,
      description: this.form.value.description,
      priority: this.form.value.priority,
      status: this.form.value.status,
      dueDate: this.form.value.dueDate || null
    });
  }
}
